import * as React from "react";
import { Upload, message, Button } from "antd";
import { CustomModal } from "../common/CustomModal";
import styled from "styled-components";
import {
  TESTIMONIAL_USER_IMAGE_UPLOAD_PATH,
  TESTIMONIAL_USER_IMAGE_PREVIEW_PATH,
} from "../../constant/comman";

const Dragger = Upload.Dragger;

const StyledDragger = styled(Dragger)`
  & .ant-upload {
    margin-bottom: 15px;
  }

  & .ant-upload-drag {
    margin-bottom: 15px;
  }
  & .ant-upload-list-item-actions {
    display: none;
  }
`;

var isUploadClick = false;

export class AddTestimonialUserImage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      disable: true,
      fileList: [],
      disableUpload: true,
    };
    this.handleChange = this.handleChange.bind(this);
    this.verifyDoc = this.verifyDoc.bind(this);
  }

  componentDidMount() {
    if (this.props.refx) {
      this.props.refx(this);
    }
  }

  verifyDoc() {
    isUploadClick = true;
    const { fileList } = this.state;

    if (fileList.length <= 0) {
      message.error("Please select a valid image");
      return;
    }

    const uploadedFile = fileList[0];
    const blobUrl = uploadedFile.thumbUrl || null;
    const bannerData = {
      media_name: uploadedFile.response.file,
      type: "image",
      media_type: "primary",
      blobUrl,
    };

    this.props.onUpload(uploadedFile.response.file, bannerData);
  }

  handleChange(info) {
    let newFileList = [...info.fileList];

    // Inject server preview URL once upload is done
    newFileList = newFileList.map((file) => {
      if (file.status === "done" && file.response && !file.url) {
        file.url = TESTIMONIAL_USER_IMAGE_PREVIEW_PATH + file.response.file;
      }
      return file;
    });

    this.setState({ fileList: newFileList });

    if (info.file.status !== "uploading") {
      if (newFileList.length < 1) {
        this.setState({ disable: true });
      } else {
        this.setState({ disable: false });
      }
    }

    if (info.file.status === "done") {
      if (info.file.response.code === "ERROR_IN_UPLOAD") {
        message.error(info.file.response.msg.message);
      } else {
        message.success(`${info.file.name} file uploaded successfully.`);
      }
    } else if (info.file.status === "error") {
      message.error(`${info.file.name} file upload failed.`);
    }
  }

  handleCancel = (e) => {
    this.hide();
  };

  show() {
    this.setState({
      visible: true,
      fileList: [],
      disable: true,
    });
    isUploadClick = false;
  }

  hide() {
    const { fileList } = this.state;
    this.setState(
      {
        visible: false,
      },
      () =>
        isUploadClick
          ? this.props.onUpload(fileList[0]?.response?.file, {
              media_name: fileList[0]?.response?.file,
              type: "image",
              media_type: "primary",
            })
          : this.props.onUpload(null)
    );
  }

  render() {
    const uploadProps = {
      action: TESTIMONIAL_USER_IMAGE_UPLOAD_PATH,
      headers: {
        authorization: "authorization-text",
      },
    };

    return (
      <CustomModal
        width="600px"
        title="Upload Testimonial Image"
        visible={this.state.visible}
        onClose={this.handleCancel.bind(this)}
        maskClosable={false}
      >
        <div className="premium-upload-container">
          <StyledDragger
            accept=".png,.jpeg,.jpg"
            className="premium-upload-dragger"
            listType="picture"
            fileList={this.state.fileList}
            {...uploadProps}
            onChange={this.handleChange}
            onRemove={(file) => {
              this.setState((prev) => ({
                fileList: prev.fileList.filter((f) => f.uid !== file.uid),
                disable: prev.fileList.length <= 1,
              }));
            }}
          >
            <div className="premium-upload-icon-wrapper">
              <svg viewBox="0 0 24 24">
                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4M17 8l-5-5-5 5M12 3v12" />
              </svg>
            </div>
            <p className="premium-upload-text">
              Click or drag image to this area
            </p>
            <p className="premium-upload-hint">
              Supports single image upload (.png, .jpeg, .jpg)
            </p>
          </StyledDragger>

          <div className="premium-upload-actions">
            <Button
              className="premium-cancel-btn"
              onClick={this.handleCancel.bind(this)}
            >
              Cancel
            </Button>
            <Button
              className="premium-upload-btn"
              disabled={this.state.disable}
              onClick={this.verifyDoc}
            >
              Upload
            </Button>
          </div>
        </div>
      </CustomModal>
    );
  }
}
